import cn from './ModalMessageErrorContent.module.scss'
import ModalMessageErrorField from './ModalMessageErrorField/ModalMessageErrorField'
import { formatErrorDetails, getErrorInfo } from './modalMessageErrorInfo'

interface ModalMessageErrorContentProps {
  title: string
  error: unknown
}

const EMPTY_FIELD_VALUE = '—'

function ModalMessageErrorContent({
  title,
  error,
}: ModalMessageErrorContentProps) {
  const { message, details, traceId } = getErrorInfo(error)

  const fields = [
    { label: 'Сообщение', value: `${message}` },
    { label: 'Подробности', value: formatErrorDetails(details) },
    { label: 'TraceID', value: traceId },
  ]

  return (
    <div className={cn.content}>
      <div className={cn.title}>{title}</div>
      {fields.map((field) => (
        <ModalMessageErrorField
          key={field.label}
          label={field.label}
          value={field.value || EMPTY_FIELD_VALUE}
        />
      ))}
    </div>
  )
}

export default ModalMessageErrorContent
